import { createContext, FC, ReactNode, useContext } from "react";

interface RunContextType {
  runId: string | null;
}

const RunContext = createContext<RunContextType>({
  runId: null,
});

interface RunProviderProps extends RunContextType {
  children: ReactNode;
}

export const RunProvider: FC<RunProviderProps> = ({ children, runId }) => {
  return (
    <RunContext.Provider value={{ runId }}>{children}</RunContext.Provider>
  );
};

export const useRunContext = (): RunContextType => {
  const context = useContext(RunContext);
  if (context === undefined) {
    throw new Error("useRunContext must be used within a RunProvider");
  }
  return context;
};
